const loadEnvironment = () => {
  const environment = {};
  Object.keys(process.env)
    .filter((key) => key.includes("REACT_APP_"))
    .forEach((key) => {
      environment[key.replace("REACT_APP_", "")] = process.env[key];
    });

  return environment;
};

export default loadEnvironment();
